import { JSX } from 'react';
import UploadFile from '@mui/icons-material/UploadFile';
import { useTheme } from '@mui/material/styles';

/**
 * Upload icon shown on answer options that trigger a file-upload question.
 * Uses `info.dark` in light mode and `info.lighter` in dark mode so it keeps
 * a &ge;3:1 non-text contrast against `background.paper` in both modes.
 */
export default function FileUploadRequiredIcon(): JSX.Element {
  const theme = useTheme();
  const color = theme.palette.mode === 'dark' ? 'info.lighter' : 'info.dark';
  return <UploadFile sx={{ fontSize: 24, color, flexShrink: 0 }} />;
}
